import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from './Typography';

// Interfaces

interface GoogleStarsProps {
  rating: number; // Rating between 4 and 5 (e.g., 4.0, 4.5, 5.0)
  inverse?: boolean; // Turn Google logo white
  url: string; // URL to Google reviews
}

// Styles

const StyledGoogleStars = styled.a`
  ${({ theme: { space, media } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.md};

    svg {
      height: 24px;
    }
  `};
`;

const StyledLogo = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    gap: ${space.md};
    align-items: center;
  `};
`;

const GoogleLogo = ({ inverse }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 77 27">
    <path
      fill={inverse ? '#fff' : '#EA4335'}
      d="M32.767 13.356c0 3.615-2.828 6.279-6.298 6.279s-6.299-2.664-6.299-6.279c0-3.64 2.828-6.279 6.299-6.279 3.47 0 6.298 2.639 6.298 6.279Zm-2.757 0c0-2.259-1.639-3.805-3.541-3.805-1.903 0-3.542 1.546-3.542 3.805 0 2.236 1.64 3.805 3.542 3.805s3.541-1.571 3.541-3.805Z"
    />
    <path
      fill={inverse ? '#fff' : '#FBBC05'}
      d="M46.356 13.356c0 3.615-2.828 6.279-6.299 6.279-3.47 0-6.299-2.664-6.299-6.279 0-3.638 2.828-6.279 6.299-6.279 3.47 0 6.299 2.639 6.299 6.279Zm-2.758 0c0-2.259-1.639-3.805-3.541-3.805s-3.541 1.546-3.541 3.805c0 2.236 1.639 3.805 3.541 3.805s3.541-1.571 3.541-3.805Z"
    />
    <path
      fill={inverse ? '#fff' : '#4285F4'}
      d="M59.378 7.456V18.73c0 4.637-2.735 6.53-5.968 6.53-3.043 0-4.874-2.035-5.565-3.7l2.4-.998c.428 1.022 1.475 2.227 3.162 2.227 2.07 0 3.352-1.276 3.352-3.68v-.903h-.096c-.617.762-1.806 1.427-3.307 1.427-3.139 0-6.015-2.735-6.015-6.253 0-3.545 2.876-6.302 6.015-6.302 1.498 0 2.687.665 3.307 1.404h.096V7.46h2.619v-.003Zm-2.423 5.923c0-2.211-1.475-3.828-3.352-3.828-1.903 0-3.496 1.617-3.496 3.828 0 2.188 1.593 3.782 3.496 3.782 1.877 0 3.352-1.594 3.352-3.782Z"
    />
    <path fill={inverse ? '#fff' : '#34A853'} d="M63.695.85v18.4h-2.69V.85h2.69Z" />
    <path
      fill={inverse ? '#fff' : '#EA4335'}
      d="m74.175 15.423 2.14 1.426c-.69 1.022-2.355 2.783-5.232 2.783-3.567 0-6.23-2.757-6.23-6.279 0-3.734 2.686-6.279 5.922-6.279 3.258 0 4.852 2.594 5.373 3.995l.286.713-8.394 3.476c.643 1.26 1.642 1.903 3.043 1.903 1.405 0 2.378-.69 3.092-1.738Zm-6.588-2.26 5.611-2.33c-.308-.783-1.237-1.33-2.33-1.33-1.401 0-3.352 1.238-3.28 3.66Z"
    />
    <path
      fill={inverse ? '#fff' : '#4285F4'}
      d="M9.99 11.723V9.059h8.977c.088.464.133 1.013.133 1.608 0 1.998-.546 4.47-2.307 6.23-1.713 1.784-3.901 2.735-6.8 2.735-5.373 0-9.891-4.376-9.891-9.75C.102 4.51 4.62.134 9.993.134c2.973 0 5.09 1.166 6.68 2.687L14.795 4.7c-1.14-1.07-2.686-1.903-4.804-1.903-3.923 0-6.992 3.162-6.992 7.086 0 3.923 3.069 7.085 6.992 7.085 2.545 0 3.995-1.022 4.923-1.95.753-.753 1.248-1.829 1.444-3.298l-6.367.003Z"
    />
  </svg>
);

const FourStars = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 25">
    <path
      fill="#FDB404"
      d="m12 18.113 4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L8.786 8.23l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L12 18.114ZM36 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L32.786 8.23l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L36 18.114ZM60 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L56.786 8.23l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L60 18.114ZM84 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L80.786 8.23l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L84 18.114Z"
    />
    <path
      fill="#EEE"
      d="m108 18.113 4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L108 18.114Z"
    />
  </svg>
);

const FourAndHalfStars = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 25">
    <path
      fill="#FDB404"
      d="m12 18.113 4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L8.786 8.231l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L12 18.113ZM36 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L36 18.113ZM60 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L60 18.113ZM84 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L84 18.113Z"
    />
    <path
      fill="#EEE"
      d="m108 17.848 4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.6.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12L108 17.849Z"
    />
    <path
      fill="#FDB404"
      fillRule="evenodd"
      d="M108 2.002a1.022 1.022 0 0 0-1.01.629l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.89.759 1.594 1.543 1.12l4.969-2.998.057.034V2.002Z"
      clipRule="evenodd"
    />
  </svg>
);

const FiveStars = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 25">
    <path
      fill="#FDB404"
      d="m12 18.113 4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0L8.786 8.231l-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L12 18.113ZM36 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L36 18.113ZM60 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L60 18.113ZM84 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L84 18.113ZM108 18.113l4.969 2.999c.784.473 1.751-.23 1.543-1.121l-1.319-5.653 4.391-3.804c.692-.599.322-1.736-.59-1.813l-5.78-.49-2.261-5.335c-.357-.841-1.549-.841-1.906 0l-2.261 5.335-5.78.49c-.912.077-1.282 1.214-.59 1.813l4.391 3.804-1.319 5.653c-.208.891.759 1.594 1.543 1.121L108 18.113Z"
    />
  </svg>
);

export const GoogleStars: React.FC<GoogleStarsProps> = ({ rating, inverse, url, ...rest }) => {
  let StarsComponent;

  if (rating >= 4.0 && rating < 4.25) {
    StarsComponent = FourStars;
  } else if (rating >= 4.25 && rating < 4.75) {
    StarsComponent = FourAndHalfStars;
  } else if (rating >= 4.75 && rating <= 5) {
    StarsComponent = FiveStars;
  } else {
    return null;
  }

  return (
    <StyledGoogleStars href={url} target="_blank" {...rest}>
      <Typography component="span" variant="titleExtraSmall" visuallyHidden>
        Google review {rating} stars.
      </Typography>
      <StyledLogo aria-hidden="true">
        <GoogleLogo inverse={inverse} />
        <StarsComponent />
      </StyledLogo>
    </StyledGoogleStars>
  );
};
